import 'leaflet/dist/leaflet';
import 'leaflet.markercluster/dist/leaflet.markercluster';
import { distanceEntre, trierParDistance } from './utils';

/**
 * L'objet cartographie est initialisé dans `window.carto` après que l'utilisateur
 * ait autorisé ou non la geolocalisation.
 *
 * @class Cartographie
 */
class Cartographie {
    /**
     * Objet principal de la carte.
     * @type {L.Map}
     **/
    map;

    /**
     * @type {L.MarkerClusterGroup}
     **/
    cluster;

    /**
     * @type {L.TileLayer}
     **/
    CartoDB_Positron;

    /**
     * @type {L.Control.Zoom}
     **/
    zoomControl;

    /**
     * Icône des marqueurs.
     * @type {L.Icon}
     **/
    customIcon;

    /**
     * Icône du marqueur actif.
     * @type {L.Icon}
     **/
    customIconActive;

    /**
     * Liste des points issue de la bdd.
     * @type {any[]}
     */
    points;

    /**
     * Latitude de l'utilisateur.
     * @type {number}
     */
    userLat;

    /**
     * Longitude de l'utilisateur.
     * @type {number}
     */
    userLong;
    /**
     * Si l'utilisateur autorise le tracking.
     * @type {boolean}
     **/
    userAutoriseTracking;

    /**
     * Dernière donnée de clic pour savoir si la popup doit être affichée ou masquée.
     * En cas de double clic sur un marqueur ou de clic d'un marqueur à l'autre.
     * Contient latitude et longitude
     * @type {number[]}
     */
    lastData = [];

    /**
     * @type {number}
     */
    zoom;

    /**
     * @type {number}
     */
    clickZoom;

    /**
     * @type {L.Marker[]}
     */
    markers = [];

    /**
     * @param {boolean} allow
     * @param {any} points
     * @param {number} lat
     * @param {number} lng
     */
    constructor(allow, points, lat = 46.426499, lng = 2.684939) {
        this.userLat = lat;
        this.userLong = lng;
        this.userAutoriseTracking = allow;
        this.points = points;
        this.zoom = 10;
        if (!allow) {
            this.zoom = 6;
        }
        this.clickZoom = 15;
        this.initMap(lat, lng);
    }

    /**
     * Initialise la carte et place les marqueurs.
     *
     * @param {number} lat Latitude du centre de la carte.
     * @param {number} lng Longitude du centre de la carte.
     */
    initMap(lat, lng) {
        const maxBounds = new L.LatLngBounds(L.latLng(-89.98155760646617, -180), L.latLng(89.99346179538875, 180));
        this.map = L.map('mapContainer', {
            center: [lat, lng],
            zoomControl: false,
            zoom: this.zoom,
            scrollWheelZoom: false,
            maxBounds,
            maxBoundsViscosity: 0.5,
        });

        this.cluster = L.markerClusterGroup({
            showCoverageOnHover: false,
        });

        this.CartoDB_Positron = L.tileLayer(
            'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}{r}.png',
            {
                attribution:
                    '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
                subdomains: 'abcd',
                maxZoom: 19,
                minZoom: 2.5,
                noWrap: true,
            }
        ).addTo(this.map);

        this.zoomControl = L.control
            .zoom({
                position: 'topleft',
            })
            .addTo(this.map);

        this.customIcon = L.icon({
            iconUrl: globalUrl + '/application/themes/ofal/img/pictos/marker01.svg',
            iconSize: [32, 42],
            iconAnchor: [16, 42],
            popupAnchor: [0, -42],
        });

        this.customIconActive = L.icon({
            iconUrl: globalUrl + '/application/themes/ofal/img/pictos/marker02.svg',
            iconSize: [32, 42],
            iconAnchor: [16, 42],
            popupAnchor: [0, -42],
        });

        // On écoute le clic sur le bouton de fermeture de la popup
        $('.carteInteractive-popup-close').on('click', function() {
            $('.carteInteractive-popup').removeClass('active');
            return false;
        });

        // Si l'utilisateur refuse la localisation, on ne peut pas déterminer la distance entre sa position
        // et le point, on trie donc les points alphabetiquement par défaut.
        if (this.userAutoriseTracking) {
            this.points = trierParDistance(this.points, { lat: this.userLat, lng: this.userLong });
        }

        $.each(this.points, (value) => {
            const val = this.points[value];
            const latlng = [Number(val.latitude), Number(val.longitude)];
            this.ajoutPoint(
                latlng,
                val.nom,
                val.adresse,
                val['code_postal'],
                val.ville,
                val.telephone,
                val.mail,
                val['site'],
                val.id
            );
            this.ajouteLigneMagasin(val.nom, val.ville, latlng[0], latlng[1], val.pays, val);
        });

        this.map.addLayer(this.cluster);
    }

    /**
     * Ajoute un nouveau marqueur depuis les données fournis.
     *
     * @param {L.LatLngExpression} tableau
     * @param {string} nom
     * @param {string} adresse
     * @param {string} codePostal
     * @param {string} ville
     * @param {string} telephone
     * @param {string} mail
     * @param {string} site
     * @param {string} id
     */
    ajoutPoint(tableau, nom, adresse, codePostal, ville, telephone, mail, site, id) {
        // On mets le this dans le scope de la variable pour pour l'utiliser dans le callback de marker()
        const self = this;
        const mrk = L.marker(tableau, {
            id: id,
            icon: this.customIcon,
            nom: nom,
            adresse: adresse,
            code_postal: codePostal,
            ville: ville,
            telephone: telephone,
            mail: mail,
            site: site,
        })
            .addTo(this.cluster)
            .on('click', function(data) {
                self.changeContenuPopup(
                    data.target.options,
                    distanceEntre(
                        { lat: data.latlng.lat, lng: data.latlng.lng },
                        { lat: self.userLat, lng: self.userLong }
                    )
                );
                self.showPopup(data.latlng.lat, data.latlng.lng);
                self.passageEnActif($(`#bouton-selection-mag-${data.target.options.id}`));
                self.definirMarkerActif(mrk);
                return false;
            });
        this.markers.push(mrk); //on ajoute le point au tableau des points
    }

    /**
     * Cette fonction défini un marqueur actif et désactive tous les autres (passe l'icone en orange).
     *
     * @param {L.Marker} mrk
     */
    definirMarkerActif(mrk) {
        this.markers.forEach((item) => {
            item.setIcon(this.customIcon);
        });
        mrk.setIcon(this.customIconActive);
    }

    /**
     * Trouve un marqueur par latitude et longitude.
     *
     * @param {number} lat
     * @param {number} lng
     * @return {boolean|L.Marker}
     */
    obtenirMarkerParLatLng(lat, lng) {
        let toReturn = false;
        this.markers.forEach((item) => {
            if (item._latlng.lat == lat && item._latlng.lng == lng) toReturn = item;
        });
        return toReturn;
    }

    /**
     * Affiche, masque ou actualise la popup.
     *
     * @param {number} latitude
     * @param {number} longitude
     */
    showPopup(latitude, longitude) {
        // On regarde si la popup est différente de la dernière popup affichée
        const popupDifferent = latitude == this.lastData['latitude'] && longitude == this.lastData['longitude'];
        this.map.setView([latitude, longitude], this.clickZoom, { animate: true, duration: 4 });

        if (!popupDifferent && this.lastData != [] && $('.carteInteractive-popup').hasClass('active')) {
            // On masque la popup 300ms puis on la réaffiche (effet d'actualisation)
            $('.carteInteractive-popup')
                .toggleClass('active', 300)
                .toggleClass('active');
        } else {
            $('.carteInteractive-popup').toggleClass('active');
        }

        // On sauvegarde la latitude et la longitude de la popup pour pouvoir comparer au prochain clic
        this.lastData['latitude'] = latitude;
        this.lastData['longitude'] = longitude;
    }

    /**
     * Mets à jour le contenu de la popup.
     *
     * @param {any{}} point
     * @param {number} distance
     */
    changeContenuPopup(point, distance) {
        // On initialise la string distanceHtml qui correspond à l'affichage de la distance
        let distanceHtml = '';

        // On regarde si le client autorise l'accès à la géolocalisation,
        // si c'est le cas alors on met dans distanceHtml la balise html pour afficher la distance dans la popup
        if (this.userAutoriseTracking) {
            distanceHtml = `<div class="tip--lg text-secondary"><i class="icon-target"></i>${distance} km</div>`;
        }

        $('.carteInteractive-popup-contenu').html(`
      ${distanceHtml}
       <h2 class="titre4--lowercase">${point.nom} - ${point.ville}</h2>
       <ul class="carteInteractive-popup-infos">
          <li>
              <i class="icon-map-pin"></i>
              ${adresseTrad} :<br>
              ${point.adresse},<br>
              ${point['code_postal']} ${point.ville}
          </li>

        ${point.telephone ? 
            `<li>
                <i class="icon-phone"></i>
                ${telephoneTrad} : ${point.telephone}
            </li>`
        : ``}
          
        ${point.mail ? 
            `<li>
                <i class="icon-mail"></i>
                ${mailTrad} : <a href="mailto:${point.mail}" target="_blank">${point.mail}</a>
            </li>`
        : ``}

        ${point.site ? 
            `<li>
                <i class="icon-link"></i>
                ${siteWeb} : <a href="${point.site}" target="_blank">${point.site}</a>
            </li>`
        : ``}
          
      </ul>`);
    }

    /**
     * Enlève la classe `'active'` de tous les `'.carteInteractive-liste-item'` et l'ajoute sur
     * l'objet.
     *
     * @param {JQuery<HTMLElement>} obj
     */
    passageEnActif(obj) {
        $('.carteInteractive-liste-item').removeClass('active');
        obj.find('a').toggleClass('active');
    }

    /**
     * Ajoute une nouvelle ligne à la liste des magasin.
     *
     * @param {string} nom
     * @param {string} ville
     * @param {string} latitude
     * @param {string} longitude
     * @param {string} pays
     * @param {any{}} data
     */
    ajouteLigneMagasin(nom, ville, latitude, longitude, pays, data) {
        const distance = distanceEntre({ lat: latitude, lng: longitude }, { lat: this.userLat, lng: this.userLong });
        let distanceHtml = `<span class="lieu"><i class="icon-crosshair"></i> ${ville}</span>`;
        if (this.userAutoriseTracking) {
            distanceHtml = `<span class="tip distance">${ville} - ${distance} km</span>`;
        }
        $(`#onglet-${pays.toLowerCase()}-contenu`).append(
            `<li id='bouton-selection-mag-${data.id}'>
              <a class="carteInteractive-liste-item" href="#">
                  <h2 class="carteInteractive-liste-titre">${nom}</h2>
                  ${distanceHtml}
              </a>
          </li>`
        );
        $(`#bouton-selection-mag-${data.id}`).on('click', () => {
            window.carto.map.setView([latitude, longitude], this.map.getZoom(), {
                animate: true,
                pan: { duration: 0.5 },
            });
            window.carto.showPopup(latitude, longitude);
            window.carto.changeContenuPopup(data, distance);
            window.carto.passageEnActif($(`#bouton-selection-mag-${data.id}`));
            window.carto.definirMarkerActif(window.carto.obtenirMarkerParLatLng(latitude, longitude));
            return false;
        });
    }
    /**
     * Supprime toutes les lignes du magasin.
     *
     * @param {string} pays
     */
    resetLigneMagasin(pays) {
        $(`#onglet-${pays.toLowerCase()}-contenu`).empty();
    }
}

export { Cartographie };
